import { render, staticRenderFns } from "./quiz-onboarding-questionnaire.vue?vue&type=template&id=69274b46&"
import script from "./quiz-onboarding-questionnaire.vue?vue&type=script&lang=js&"
export * from "./quiz-onboarding-questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./quiz-onboarding-questionnaire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports